import { Card, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn } from "components";
import { ExportGridData, ReportPropertyBase } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const ExportGrid = (props: {
  exportType: string | undefined;
  exportSubType: string | undefined;
  timezone: string | undefined;
  gridData: ExportGridData;
}) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  // 1. Move helper function here so both onExporting and the JSX can access it
  const getCustomHeader = () => {
    const type = props.exportType || "";
    const subType = props.exportSubType || "";

    if (!subType) return type;

    // Split both into arrays of words
    const typeWords = type.split(" ");
    const subTypeWords = subType.split(" ");

    // Filter out words from the subtype if they appear in the main type
    const cleanSubWords = subTypeWords.filter(word => !typeWords.includes(word));

    // If the subtype had unique words, append them cleanly. Otherwise, just return the subtype.
    return cleanSubWords.length > 0 ? `${type} ${cleanSubWords.join(" ")}` : subType;
  };

  const onExporting = () => {
    let infoTuples: [string, string | undefined][] = [];

    props.gridData.filterDisplays?.forEach((filterDisplay) => {
      infoTuples.push([
        `${filterDisplay.label!}${filterDisplay.operator ? ` (${filterDisplay.operator})` : ""}`,
        filterDisplay.values?.join(", "),
      ]);
    });

    const currentDate = new Date().toLocaleDateString("sv-SE");

    return {
      header: getCustomHeader(),
      filename: `${appTenantName}_${props.exportType}${props.exportSubType ?? ""}_${currentDate}`,
      tenantName: appTenantName,
      infoTuples: infoTuples,
    };
  };

  return (
    <Card header={getCustomHeader()}>
      <DevExpressReport
        dataSource={props.gridData.rows}
        onExporting={onExporting}
        exportFormats={["excel", "csv", "pdf"]}
      >
        {props.gridData.columns?.map((property) =>
          renderReportColumn({
            property: property,
            propertyKey: pn<ReportPropertyBase>("fullIdentifier"),
            timezone: props.timezone,
          })
        )}
      </DevExpressReport>
    </Card>
  );
};
